<template>
  <v-app class="app">
    <Cookie></Cookie>
    <navigation></navigation>
    <div v-if="isLoading" class="loading-container">
      <v-container class="fill-height">
        <v-row>
          <v-col class="text-center">
            <v-progress-circular
              size="50"
              indeterminate
              color="primary"
            ></v-progress-circular>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <v-content>
      <router-view></router-view>
    </v-content>
    <hdsinfo></hdsinfo>
    <app-footer></app-footer>
  </v-app>
</template>

<script>
import Cookie from "@/components/layout/Cookie.vue";
import Navigation from "@/components/layout/Navigation.vue";
import AppFooter from "@/components/layout/Footer.vue";
import Hdsinfo from "@/components/layout/Hdsinfo.vue";

export default {
  name: "App",
  components: {
    Cookie,
    Navigation,
    AppFooter,
    Hdsinfo
  },
  computed: {
    isLoading() {
      return this.$store.getters.isLoading;
    }
  }
};
</script>

<style scoped>
.app {
  background-color: #eceff4 !important;
}

.loading-container {
  display: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  z-index: 1000000;
  background-color: rgba(255, 255, 255, 0.4);
}
</style>
